export const Symbols = {
    VueI18n: Symbol('VueI18n'),
};

export const INPUT_LIMIT_LENGTH = 5000;

export const OPEN_DELAY = 500;

export const TASK_TYPE = {
    SEARCH: 'AI_SEARCH',
    CLMS: 'AI_CLAIM',
    IMAGE: 'AI_IMAGE',
    TRANSLATION: 'AI_TRANSLATION',
    DISCLOSURE: 'PATENT_DISCLOSURE',
};
